// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentBlocks_container__JqVGO"};